import React from 'react';
import Button from '@atlaskit/button';
import WarningIcon from '@atlaskit/icon/core/migration/warning';
import { Stack, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const CardContentsErrorState = ({
	onRefetch,
}: {
	onRefetch: ({ triggerLoadingState }: { triggerLoadingState: boolean }) => void;
}) => {
	const { formatMessage } = useIntl();
	const onClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
		e.stopPropagation();
		onRefetch({ triggerLoadingState: true });
	};

	return (
		<Stack alignInline="center" xcss={errorStateContainerStyles}>
			<WarningIcon spacing="spacious" label="" color={token('color.icon.warning')} />
			{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
			<p>{formatMessage(messages.errorMessage)}</p>
			<Button appearance="link" onClick={onClick}>
				{formatMessage(messages.tryAgain)}
			</Button>
		</Stack>
	);
};

const errorStateContainerStyles = xcss({
	paddingTop: 'space.100',
	paddingBottom: 'space.100',
});
